import { defineStore } from 'pinia';
import { ref } from 'vue';
import { store } from '@/common/root';
import api from '@/common/utils/api';
import NotFoundError from '@/common/utils/errors/NotFoundError';
import { TotpConfig } from '@schema';

export const TOTP_KEY = 'totp';

const TOTP_CONFIG_API_URL = '/api/v2/accounts/totp/config/';

export const useTotpSettingsStore = defineStore('totpSettings', () => {
  const generalTotp = ref<TotpConfig | null>(null);

  const fetchGeneralTotp = async (): Promise<TotpConfig | null> => {
    try {
      const response = await api.get<TotpConfig>(TOTP_CONFIG_API_URL);
      generalTotp.value = response.data;
      return response.data;
    } catch (error) {
      if (error instanceof NotFoundError) {
        generalTotp.value = null;
        return null;
      }
      throw error;
    }
  };

  const setGeneralTotp = async (mandatory: boolean): Promise<TotpConfig> => {
    const response = await api.put<TotpConfig>(TOTP_CONFIG_API_URL, { mandatory });
    generalTotp.value = response.data;
    return response.data;
  };

  const setDomainTotp = (domainId: string, enabled: boolean) => store.dispatch('domains/domains/UPDATE', {
    id: domainId,
    body: { totp_mandatory: enabled },
  });

  return {
    generalTotp,
    fetchGeneralTotp,
    setGeneralTotp,
    setDomainTotp
  };
});

export default useTotpSettingsStore;
